const errorIcon = `
    <svg class="directory-error-swal__svg" width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <circle class="directory-error-swal__circle" cx="36" cy="36" r="31" />
        <path class="directory-error-swal__line directory-error-swal__line--left" d="M26 26L46 46" />
        <path class="directory-error-swal__line directory-error-swal__line--right" d="M46 26L26 46" />
    </svg>
`

function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    }[char]))
}

function resolveDuplicateValue(duplicateValue, fieldName) {
    if (!duplicateValue) {
        return ''
    }

    if (typeof duplicateValue === 'object') {
        return String(duplicateValue[fieldName] || duplicateValue.name || duplicateValue.email || '').trim()
    }

    return String(duplicateValue).trim()
}

function normalizeDuplicateMessage(value, duplicateValue = '') {
    const normalized = String(value || '').trim().toLowerCase().replace(/[.!]$/, '').replace(/\s+/g, ' ')
    const alreadyExistsMatch = normalized.match(/^(.+?)\s+already\s+exists?$/)
    const alreadyExistMatch = normalized.match(/^(.+?)\s+already\s+exist$/)
    const duplicateTarget = alreadyExistsMatch?.[1] || alreadyExistMatch?.[1]

    if (!duplicateTarget) {
        return ''
    }

    const cleanTarget = duplicateTarget
        .replace(/\b(costcode)\b/g, 'cost code')
        .replace(/\s+/g, ' ')
        .trim()
    const fieldName = cleanTarget.endsWith(' email') || cleanTarget === 'email' ? 'email' : 'name'
    const selectedValue = resolveDuplicateValue(duplicateValue, fieldName)

    if (selectedValue) {
        return `This ${selectedValue} ${fieldName} is already in use. Please enter a different ${fieldName}.`
    }

    return `This ${cleanTarget} is already in use. Please enter a different ${fieldName}.`
}

function normalizeDescription(value, duplicateValue = '') {
    if (!value) {
        return 'Please try again. If the problem persists, contact your administrator.'
    }

    if (typeof value === 'string') {
        const duplicateMessage = normalizeDuplicateMessage(value, duplicateValue)
        if (duplicateMessage) {
            return duplicateMessage
        }

        return value
    }

    if (value.message) {
        const duplicateMessage = normalizeDuplicateMessage(value.message, duplicateValue)
        if (duplicateMessage) {
            return duplicateMessage
        }

        return value.message
    }

    if (value.error) {
        const duplicateMessage = normalizeDuplicateMessage(value.error, duplicateValue)
        if (duplicateMessage) {
            return duplicateMessage
        }

        return value.error
    }

    return JSON.stringify(value)
}

export function showDirectoryError(vm, options = {}) {
    const {
        title = 'Sorry, there was a problem.',
        description = '',
        duplicateValue = '',
        showCloseButton = true
    } = options

    return vm.$swal({
        title,
        html: escapeHtml(normalizeDescription(description, duplicateValue)).replace(/\n/g, '<br />'),
        icon: 'error',
        iconHtml: errorIcon,
        buttonsStyling: false,
        showCloseButton,
        showConfirmButton: false,
        customClass: {
            popup: 'directory-error-swal',
            icon: 'directory-error-swal__icon',
            title: 'directory-error-swal__title',
            htmlContainer: 'directory-error-swal__text',
            closeButton: 'directory-error-swal__close'
        }
    })
}
